import React from 'react';
import { cn } from '../../../ui';

const CHIP_TONE_CLASSES = {
  primary: 'tw-bg-primary-soft tw-text-primary',
  violet: 'tw-bg-chart-1-soft tw-text-chart-1',
  emerald: 'tw-bg-success-soft tw-text-success',
  sky: 'tw-bg-info-soft tw-text-info',
  amber: 'tw-bg-warning-soft tw-text-warning',
  rose: 'tw-bg-danger-soft tw-text-danger',
  neutral: 'tw-bg-surface-sunken tw-text-content-muted',
};

/** The tinted disc or tile behind a card's icon. Decorative: the row beside it has the words. */
const IconChip = ({ icon: Icon, tone = 'primary', round = false, size = 34, iconSize = 16, className }) => (
  <span
    aria-hidden="true"
    style={{ width: size, height: size }}
    className={cn(
      'tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center',
      round ? 'tw-rounded-full' : 'tw-rounded-md',
      CHIP_TONE_CLASSES[tone] || CHIP_TONE_CLASSES.primary,
      className,
    )}
  >
    <Icon size={iconSize} />
  </span>
);

export default IconChip;
